import {t} from "@lingui/core/macro";
import memoize from "lodash.memoize";

import {type MasteryLevel} from "@khan/content-types";

export const masteryValueConstants = {
    UNFAMILIAR: "unfamiliar" as const,
    ATTEMPTED: "attempted" as const,
    FAMILIAR: "familiar" as const,
    PROFICIENT: "proficient" as const,
    MASTERED: "mastered" as const,
} as const;

export const constants = {
    ...masteryValueConstants,

    LEVEL1: "level1",
    LEVEL2: "level2",
    LEVEL3: "level3",
    LEVEL4: "level4",
    LEVEL5: "level5",
    LEVEL6: "level6",

    STARTED: "started",
    COMPLETE: "complete",
} as const;

export const masteryValues = [
    constants.UNFAMILIAR,
    constants.ATTEMPTED,
    constants.FAMILIAR,
    constants.PROFICIENT,
    constants.MASTERED,
] as const;

export const getLevelChange = (
    start?: MasteryLevel | null,
    end?: MasteryLevel | null,
): number => {
    if (!start || !end) {
        return 0;
    }
    if (start === constants.UNFAMILIAR && end === constants.ATTEMPTED) {
        return -1;
    }

    return masteryValues.indexOf(end) - masteryValues.indexOf(start);
};

export const getMasteryDisplayNames: () => {
    attempted: string;
    familiar: string;
    mastered: string;
    proficient: string;
    unfamiliar: string;
} = memoize(() => ({
    [constants.UNFAMILIAR]: t`Not Started`,
    [constants.ATTEMPTED]: t`Attempted`,
    [constants.FAMILIAR]: t`Familiar`,
    [constants.PROFICIENT]: t`Proficient`,
    [constants.MASTERED]: t`Mastered`,
}));

export const getMasteryDisplay = (mastery: string): string =>
    getMasteryDisplayNames()[mastery] || t`Unknown`;
